import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-admin-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  search: string = '';
  constructor(public commonService: CommonService) { }

  ngOnInit() {}

  toggleSearch() {
    if (this.search === '') {
      this.search = 'opened';
    } else {
      this.search = '';
    }
  }
}
